import React, { useEffect, useState } from 'react';
import './styles.scss';

interface PermalinkProps {
  /** Path part of the link, e.g. `/my-analyses/c/2026…`; the origin is prepended. */
  path: string;
  /** Whether this link opens for anyone (shared) or only for the owner. */
  isPublic: boolean;
}

/**
 * The full, selectable permalink of the open analysis / conversation with a
 * one-click copy button, so the exact URL is always visible for sharing.
 */
const Permalink: React.FC<PermalinkProps> = ({ path, isPublic }) => {
  const url = `${window.location.origin}${path}`;
  const [copied, setCopied] = useState(false);

  useEffect(() => { setCopied(false); }, [url]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // Clipboard blocked (http, permissions): fall back to selecting the text.
      const el = document.getElementById('permalink-url');
      if (el) window.getSelection()?.selectAllChildren(el);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={`permalink ${isPublic ? 'permalink-public' : 'permalink-private'}`}>
      <span className="permalink-icon" aria-hidden="true">🔗</span>
      <a id="permalink-url" className="permalink-url" href={url} onClick={(e) => e.preventDefault()} title={url}>{url}</a>
      <button type="button" className="permalink-copy" onClick={copy}>{copied ? 'Copied ✓' : 'Copy'}</button>
      <span className="permalink-note">
        {isPublic ? 'Public link · anyone can open it' : 'Private link · only you can open it. Press Share to get a public link.'}
      </span>
    </div>
  );
};

export default Permalink;
